module.exports = __webpack_public_path__ + "img/BillingDetails.0161d11b.png";